export const isEmailValid = (email: string) => {
  const emailRegExp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  return emailRegExp.test(email)
}

export const isValidPhoneNumber = (phoneNumber: string) => {
  const phoneNumberRegExp = /^\(\d{3}\)\s\d{3}-\d{4}$/

  return phoneNumberRegExp.test(phoneNumber)
}

export const transformPhoneNumber = (input: string) => {
  const phoneNumber = input.replace(/[^0-9]/g, "")
  return phoneNumber
}

export const getPhoneNumberWithCountryPrefix = (input: string, phonePrefix: number) => {
  const unformattedPhoneNumber = transformPhoneNumber(input)
  return `+${phonePrefix}${unformattedPhoneNumber}`
}

export const nameRegex = /^[A-Za-z -]+$/
export const addressRegex = /^[A-Za-z0-9 ,.\-/#&'()]+$/
